var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 37 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: { cx: "18.2734", cy: "18.291", r: "18", fill: "#9777A8" },
      }),
      _c("path", {
        attrs: {
          d: "M27.5446 11.7642L27.2453 11.4649L23.3264 7.54602L23.0271 7.24671C22.8916 7.11123 22.7037 7.0332 22.5116 7.0332H11.2452C10.7848 7.0332 10.2891 7.38879 10.2891 8.16908V22.173V28.5927V28.7724C10.2891 29.0974 10.6159 29.4141 11.0026 29.5139C11.022 29.5189 11.0406 29.5263 11.0608 29.5302C11.1214 29.5422 11.1831 29.5488 11.2452 29.5488H26.8019C26.8641 29.5488 26.9258 29.5422 26.9863 29.5302C27.0065 29.5263 27.0252 29.5189 27.0446 29.5139C27.4312 29.4141 27.7581 29.0974 27.7581 28.7724V28.5927V22.173V12.4595C27.7581 12.1617 27.7224 11.942 27.5446 11.7642ZM26.3741 11.6916H23.0997V8.41714L26.3741 11.6916ZM11.2452 28.7724C11.2176 28.7724 11.1928 28.7623 11.1683 28.7534C11.1078 28.7247 11.0655 28.6641 11.0655 28.5927V22.9494H26.9817V28.5927C26.9817 28.6641 26.9394 28.7243 26.8788 28.7534C26.8544 28.7623 26.8295 28.7724 26.8019 28.7724H11.2452ZM11.0655 22.173V8.16908C11.0655 8.08484 11.0783 7.8096 11.2452 7.8096H22.3458C22.333 7.85852 22.3233 7.90898 22.3233 7.96139V12.468H26.8299C26.8823 12.468 26.9324 12.4583 26.9813 12.4455C26.9813 12.4513 26.9817 12.4536 26.9817 12.4595V22.173H11.0655Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M14.1367 27.9965H16.5835V27.5135H14.7842V26.2344H16.4189V25.7993H14.7842V24.5679H16.5835V24.085H14.1367V27.9965Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.5779 24.085L18.8295 25.677H18.7763L18.0865 24.085H17.3594L18.4157 26.0962L17.423 27.9965H18.1606L18.8295 26.5209H18.8827L19.5034 27.9965H20.2414L19.2487 26.0962L20.305 24.085H19.5779Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M21.1953 27.9965H23.6418V27.5135H21.8428V26.2344H23.4775V25.7993H21.8428V24.5679H23.6418V24.085H21.1953V27.9965Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M23.2148 12.8738C23.0102 12.8097 22.7924 12.9239 22.7283 13.1284L20.7873 19.3396C20.7233 19.5442 20.8374 19.762 21.042 19.8261C21.0808 19.8381 21.1196 19.8439 21.1581 19.8439C21.3235 19.8439 21.4764 19.7375 21.5284 19.5714L23.4694 13.3602C23.5335 13.1556 23.4193 12.9378 23.2148 12.8738Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.4104 15.5738C19.732 15.5738 19.9927 15.3131 19.9927 14.9915C19.9927 14.6699 19.732 14.4092 19.4104 14.4092C19.0888 14.4092 18.8281 14.6699 18.8281 14.9915C18.8281 15.3131 19.0888 15.5738 19.4104 15.5738Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.4104 18.2906C19.732 18.2906 19.9927 18.0299 19.9927 17.7083C19.9927 17.3867 19.732 17.126 19.4104 17.126C19.0888 17.126 18.8281 17.3867 18.8281 17.7083C18.8281 18.0299 19.0888 18.2906 19.4104 18.2906Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.4987 14.4092H17.2751C17.4893 14.4092 17.6633 14.2353 17.6633 14.021C17.6633 13.8067 17.4893 13.6328 17.2751 13.6328H16.4987C15.0002 13.6328 13.7812 14.8518 13.7812 16.3502C13.7812 17.8487 15.0002 19.0676 16.4987 19.0676H17.2751C17.4893 19.0676 17.6633 18.8937 17.6633 18.6794C17.6633 18.4651 17.4893 18.2912 17.2751 18.2912H16.4987C15.4284 18.2912 14.5577 17.4205 14.5577 16.3502C14.5577 15.2799 15.4284 14.4092 16.4987 14.4092Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }